// External Dependencies:
import React from 'react'

class RadioButtons extends React.Component {
	handleClick = ( e ) => {
		let id = e.target.getAttribute( 'data-id' )

		this.props.onChange( this.props.id, id )
	}

	render() {
		const { id, value, required, label, options } = this.props
		let optionsMarkup = ''

		optionsMarkup = options.map( e => {
			let className = value == e.id ? 'button -selected' : 'button -unselected'

			return (
				<div
					key={ e.id }
					className={ className }
					data-id={ e.id }
					onClick={ this.handleClick }
				>
					{ e.name }
				</div>
			)
		})

		return (
			<div className="form-item form-radio-buttons">
				{ label &&
					<label htmlFor={ id }>
						<span dangerouslySetInnerHTML={ { __html: label } } />

						{ required &&
							<span className="-required"> *</span>
						}
					</label>
				}

				{ optionsMarkup }
			</div>
		)
	}
}

export default RadioButtons



// WEBPACK FOOTER //
// ./components/Form/RadioButtons.jsx